export const memberMenu = {
	init: () => {
		const memberMenuElmt = document.querySelector( '.menu-espace-membre-container' );
		if( !memberMenuElmt ) {
			return;
		}
		memberMenuElmt.addEventListener( 'click', ( event ) => {
			const link = event.target;
			if ( link.tagName !== 'A' ) {
				return;
			}
			const parent = link.parentNode;
			if ( parent.classList.contains( 'current_page_item' ) ) {
				event.preventDefault();
				memberMenuElmt.classList.toggle( 'open' );
			}
		} );
	},
};
